/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-17 15:26:57
 * @LastEditTime: 2019-09-02 17:59:53
 * @LastEditors: Please set LastEditors
 */
import axios from 'axios';
import qs from 'qs';
import route from '@/router.js'
axios.defaults.timeout = 500000;
axios.defaults.withCredentials = true;
//http request 拦截器
// axios.defaults.baseURL = process.env.VUE_APP_URL
// axios.defaults.baseURL = process.env.VUE_APP_URL    
var apis={
};
if(process.env.VUE_APP_type== 'development'){
    apis={
        login:'http://login.c.fulerene.com/api/v1',
        logistics:'http://dealer.c.fulerene.com/api/v1',
        logistics_1:'http://dealer.c.fulerene.com/dealer/v1',
        logistics_2:'http://pps.c.fulerene.com/index.php/',
        oem:'https://dealer.c.fulerene.com/pay/v1',
        dealer_pc:'http://dealer.c.fulerene.com/index.php/',
        local:"http://jxspps.com/index.php",
        conf:'http://logistics.c.fulerene.com/admin/v2'
    }
}else if(process.env.VUE_APP_type== 'person'){
        apis={
            login:'http://login.tx315.vip/api/v1',
            logistics:"http://dealer.tx315.vip/api/v1",
            logistics_1:'http://dealer.tx315.vip/dealer/v1',
            logistics_2:'https://pps.tx315.vip/index.php/',
            conf:'http://logistics.tx315.vip/admin/v2',
            oem:'https://dealer.tx315.vip/pay/v1',
            webUrl:'http://jifen.tx315.vip/',
            dealer_pc:'http://yxfk.qiema.cn//index.php/'
        }
}else if(process.env.VUE_APP_type== 'zd'){
    apis={
        login:'http://login.cn2de.com/api/v1',
        logistics:"http://dealer.cn2de.com/api/v1",
        logistics_1:'http://dealer.cn2de.com/dealer/v1',
        logistics_2:'https://zs.cn2de.com/index.php/',
        conf:'http://logistics.cn2de.com/admin/v2',
        oem:'https://dealer.cn2de.com/pay/v1',
         webUrl:'http://jifen.cn2de.com/'
    }
}else if(process.env.VUE_APP_type== 'ym'){
    apis={
        login:'https://login.ymbiaoshi.cn/api/v1',
        logistics:"https://dealer.ymbiaoshi.cn/api/v1",
        logistics_1:'https://dealer.ymbiaoshi.cn/dealer/v1',
        logistics_2:'https://pps.ymbiaoshi.cn/index.php/',
        conf:'https://logistics.ymbiaoshi.cn/admin/v2',
        oem:'httpss://dealer.ymbiaoshi.cn/pay/v1',
        webUrl:'https://jifen.ymbiaoshi.cn/',
        dealer_pc:'https://yxfk.qiema.cn//index.php/'
    }
}else{
    apis={
        login:'https://login.fulerene.com/api/v1',
        logistics:"https://dealer.fulerene.com/api/v1",
        logistics_1:'https://dealer.fulerene.com/dealer/v1',
        logistics_2:'https://pps.fulerene.com/index.php/',
        conf:'https://logistics.fulerene.com/admin/v2',
        oem:'https://dealer.fulerene.com/pay/v1',
        webUrl:'https://jifen.fulerene.com/',
        dealer_pc:'https://yxfk.qiema.cn//index.php/'
    }
}

export default apis
// apis={
//     login:'http://login.c.fulerene.com/api/v1',
//     logistics:'http://dealer.c.fulerene.com/api/v1',
//     logistics_1:'http://dealer.c.fulerene.com/dealer/v1',
//     logistics_2:'http://pps.c.fulerene.com/index.php/',
//     oem:'https://dealer.c.fulerene.com/pay/v1',
//     dealer_pc:'http://dealer.c.fulerene.com/index.php/',
//     local:"http://jxspps.com/index.php",
//     conf:'http://logistics.c.fulerene.com/admin/v2'
// }
axios.interceptors.request.use(
    config => {
        config.data = qs.stringify(config.data);
        config.headers = {
            'Content-Type':'application/x-www-form-urlencoded',
            'accept':'application/json',
        }
            if(localStorage.getItem('access_token')){
            config.headers.Authorization ='Bearer' + " " +localStorage.getItem('access_token');
            }

        return config;
    },
    error => {
        return Promise.reject(err);
    }
);
//http response 拦截器
axios.interceptors.response.use(
    response => {
        if(response.data.code ==100){
            location.href = location.href.split('#/')[0] + '#/login';//跳回登陆页面
        }
        return response;
    },
    error => {
        if(error.response.data){
            return Promise.reject(error.response.data)

        }
    }
)
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(module,url,params={}){
    var baseUrl=''
 
    if(module==='login'){
        baseUrl=apis.login+url
    }else if(module=='logistics'){
        baseUrl=apis.logistics+url
        
    }else if(module=='logistics_1'){
        baseUrl=apis.logistics_1+url
    }else if(module=='conf'){
        
        baseUrl=apis.conf+url
    }else if(module=='oem'){
        
        baseUrl=apis.oem+url
    }
    else if(module=='dealer_pc'){
        
        baseUrl=apis.dealer_pc+url
    }
    else if(module=='local'){
        
        baseUrl=apis.local+url
    }
    
    else
    {
        baseUrl=apis.logistics_2+url
    }
    return new Promise((resolve,reject) => {

        axios.get(baseUrl,{
            params:params
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err)
            })
    })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(module,url,data = {}){

    var baseUrl=''
    if(module==='login'){
        baseUrl=apis.login+url
    }else if(module=='logistics'){
        baseUrl=apis.logistics+url
        
    }else if(module=='logistics_1'){
        baseUrl=apis.logistics_1+url
    }else if(module=='conf'){
        
        baseUrl=apis.conf+url
    }else if(module=='oem'){
        
        baseUrl=apis.oem+url
    }else if(module=='dealer_pc'){
        
        baseUrl=apis.dealer_pc+url
    }  else if(module=='local'){
        
        baseUrl=apis.local+url
    }
    else{
        baseUrl=apis.logistics_2+url
    }
    return new Promise((resolve,reject) => {
        axios.post(baseUrl,data)
            .then(response => {
                resolve(response.data);
            },err => {
                reject(err)
            })
    })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(module,url,data = {}){
    
    var baseUrl=''
    if(module==='login'){
        baseUrl=apis.login+url
    }else if(module=='logistics'){
        baseUrl=apis.logistics+url
        
    }else if(module=='logistics_1'){
        baseUrl=apis.logistics_1+url
    }else if(module=='conf'){
        
        baseUrl=apis.conf+url
    }else if(module=='oem'){
        
        baseUrl=apis.oem+url
    }else if(module=='dealer_pc'){
        
        baseUrl=apis.dealer_pc+url
    }else if(module=='local'){
        
        baseUrl=apis.local+url
    }
    else{
        baseUrl=apis.logistics_2+url
    }
    return new Promise((resolve,reject) => {
        axios.patch(baseUrl,data)
            .then(response => {
                resolve(response.data);
            },err => {
                reject(err)
            })
    })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(module,url,data = {}){
    var baseUrl=''
    if(module==='login'){
        baseUrl=apis.login+url
    }else if(module=='logistics'){
        baseUrl=apis.logistics+url
        
    }else if(module=='logistics_1'){
        baseUrl=apis.logistics_1+url
    }else if(module=='conf'){
        
        baseUrl=apis.conf+url
    }else if(module=='oem'){
        
        baseUrl=apis.oem+url
    }else if(module=='dealer_pc'){
        
        baseUrl=apis.dealer_pc+url
    }else if(module=='local'){
        
        baseUrl=apis.local+url
    }
    else{
        baseUrl=apis.logistics_2+url
    }
    return new Promise((resolve,reject) => {
        axios.put(baseUrl,data)
            .then(response => {
                resolve(response.data);
            },err => {
                reject(err)
            })
    })
}
/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function del(module,url,data = {}){
    var baseUrl=''
    if(module==='login'){
        baseUrl=apis.login+url
    }else if(module=='logistics'){
        baseUrl=apis.logistics+url
        
    }else if(module=='logistics_1'){
        baseUrl=apis.logistics_1+url
    }else if(module=='conf'){
        
        baseUrl=apis.conf+url
    }else if(module=='oem'){
        
        baseUrl=apis.oem+url
    }else if(module=='dealer_pc'){
        
        baseUrl=apis.dealer_pc+url
    }else if(module=='local'){
        
        baseUrl=apis.local+url
    }
    else{
        baseUrl=apis.logistics_2+url
    }
    return new Promise((resolve,reject) => {
        axios.delete(baseUrl,data)
            .then(response => {
                resolve(response.data);
            },err => {
                reject(err)
            })
    })
}

